import { autoinject, transient } from "aurelia-dependency-injection";
import { bindable } from "aurelia-templating";
import { LookupClientService } from "../../services/lookups/lookup-client.service";
import { LookupValue, LookupValueRequest } from "../../models/lookup.models";
import { GuidHelper } from "../../helpers/guid.helper";

require("./comp-radio-button-lookup.scss");
@transient()
@autoinject()
export class CompRadioButtonLookup
{
    public values: LookupValue[] = [];

    @bindable
    public label: string = "";

    @bindable
    public lookup: string;

    @bindable
    public parameters: string;

    @bindable
    public toolTipProperty: string = "toolTipHtml";

    @bindable
    public value: number;

    @bindable
    public disabled: boolean = false;
    
    @bindable
    public group: string = GuidHelper.generateGuid();
    
    @bindable
    public noDefaultValue: boolean = false;

    constructor(private lookupService: LookupClientService) { }

    bind()
    {
        this.lookupChanged();
    }

    select(id: number) {
        if (!this.disabled) {
            this.value = id;
        }
    }

    parametersChanged() {
        if (this.parameters) {
            this.lookupChanged();
        }
    }

    lookupChanged() {
        if (this.lookup) {
            const request = new LookupValueRequest();
            request.lookupValueQuery = this.lookup;

            if(this.parameters)
                request.parameters = this.parameters

            this.values = [];
            this.lookupService.getLookup(request).then(x => {

                this.values = x.activeValues;
                
                if (!this.value && this.values.length && !this.noDefaultValue) 
                {
                    const defaultValue = this.values.find(x => x.isDefault == true);
                    this.value = defaultValue? defaultValue.id: this.values[0].id;
                }
            });
        }
    }

    public onTooltipClick($event: Event) {
        $event.stopPropagation();
    }

    getToolTip(value: LookupValue)
    {
        if(this.toolTipProperty && value && value.additionalData && Object.keys(value.additionalData).indexOf(this.toolTipProperty) > -1 
            && value.additionalData[this.toolTipProperty] != null && value.additionalData[this.toolTipProperty].trim() != '')
        {
            return value.additionalData[this.toolTipProperty];
        }
        else return null
    }

}